/* LCDF room-preview UI. No requests that create projects/images unless explicitly enabled. */
(function () {
  'use strict';
  var root = document.getElementById('ema-wp-root');
  if (!root || root.dataset.bound) return;
  root.dataset.bound = 'true';
  var api = (root.dataset.api || '').replace(/\/$/, '');
  var enabled = root.dataset.enabled === 'true' && /^https:\/\//.test(api);
  var emailVerificationEnabled = root.dataset.emailVerificationEnabled === 'true';
  var contactPreviewEnabled = root.dataset.contactPreviewEnabled === 'true';
  var copy = JSON.parse(document.getElementById('ema-wp-copy').textContent);
  var overlay, returnFocus, previousOverflow, timer, phase = 'intro';
  var state = { file: null, busy: false, config: null, remote: null, result: null, remaining: null, viewed: new Set(), attempt: 0, observer: null,
    previewUnit: 'cm', dimensionsCm: { width: 100, height: 100 } };
  var emailSession = null, emailTimer = null;
  function T(text, params) {
    if (typeof window !== 'undefined' && typeof window.EMAMuralTranslate === 'function')
      return window.EMAMuralTranslate(text, params);
    return String(text).replace(/\{(\w+)\}/g, function (match, key) {
      return params && Object.prototype.hasOwnProperty.call(params, key) ? String(params[key]) : match;
    });
  }
  function configuredCopy(key, fallback) {
    return typeof copy !== 'undefined' && copy && typeof copy[key] === 'string' && copy[key] ? T(copy[key]) : fallback;
  }
  function lifecycle() { return window.EMAMuralLifecycle; }
  function q(name) { return overlay.querySelector('[data-wp="' + name + '"]'); }
  function track(name, details, once) { return lifecycle() && lifecycle().emit(name, Object.assign({}, state.config || lifecycle().currentPreviewConfiguration(), details, { configuration_type: 'visualization' }), once); }
  function show(view) {
    phase = view;
    if (view === 'intro') q('reuse-photo').hidden = !state.file;
    overlay.dataset.phase = view;
    overlay.querySelectorAll('.ema-wp-view').forEach(function (element) { element.hidden = element.dataset.view !== view; });
    overlay.querySelectorAll('[data-wp-step]').forEach(function (element, index) {
      var step = view === 'intro' ? 0 : view === 'result' || view === 'loading' ? 2 : 1;
      element.dataset.active = String(index === step); element.dataset.complete = String(index < step);
      if (index === step) element.setAttribute('aria-current', 'step'); else element.removeAttribute('aria-current');
    });
    if (view === 'artwork' && q('use-crop').checked) { ensurePreviewCropper(); resizePreviewCropper(); }
    overlay.querySelector('.ema-wp-panel').scrollTop = 0;
    overlay.querySelector('.ema-wp-panel').focus({ preventScroll: true });
  }
  function notice(text) { q('notice').textContent = text || ''; q('notice').hidden = !text; }
  function setBusy(value) {
    state.busy = value; lifecycle().lockGeneration(value);
    q('email-go').disabled = value || !enabled;
    q('email-go').textContent = value ? T('Preparing…') : !contactPreviewEnabled && emailVerificationEnabled &&
      !(window.EMAMuralIdentity && typeof window.EMAMuralIdentity.verify === 'function') ? T('Email my verification code →') : T('Create my room preview →');
    q('artwork-go').disabled = value;
    ['use-crop', 'width', 'height', 'email', 'optin'].forEach(function (name) { q(name).disabled = value; });
    overlay.querySelectorAll('[data-wp-unit]').forEach(function (button) { button.disabled = value; });
    if (state.previewCropper) { if (value) state.previewCropper.disable(); else state.previewCropper.enable(); }
    overlay.querySelectorAll('[data-wp-back]').forEach(function (button) { button.disabled = value; });
    overlay.setAttribute('aria-busy', String(value));
  }
  function trials(used, limit) {
    if (!Number.isInteger(used) || !Number.isInteger(limit) || used < 0 || limit < 0) return;
    state.remaining = Math.max(0, limit - used);
    ['trials', 'trials2'].forEach(function (name) { q(name).textContent = state.remaining; });
    ['limit', 'limit2'].forEach(function (name) { q(name).textContent = limit; });
    q('trials3').textContent = state.remaining;
    overlay.querySelectorAll('[data-wp-quota]').forEach(function (card) {
      card.querySelector('[data-quota-label]').textContent = T('{remaining} of {limit} previews remaining', { remaining: state.remaining, limit: limit });
      card.querySelector('[data-quota-note]').textContent = state.remaining === 0 ?
        T('Your saved preview is still available. Continue with your mural below.') : T('Use your next preview to try another room photo.');
      card.dataset.exhausted = String(state.remaining === 0);
      var tokens = card.querySelector('[data-quota-tokens]'); tokens.replaceChildren();
      for (var i = 0; i < Math.min(20, limit); i++) { var token = document.createElement('i'); token.dataset.available = String(i < state.remaining); tokens.appendChild(token); }
    });
    q('again').disabled = state.remaining === 0;
  }
  function clearQuota() {
    state.remaining = null;
    overlay.querySelectorAll('[data-wp-quota]').forEach(function (card) {
      card.hidden = false; delete card.dataset.exhausted;
      card.querySelector('[data-quota-label]').textContent = T('Up to 3 room previews');
      card.querySelector('[data-quota-note]').textContent = T('Your available previews are checked when you continue.');
      var tokens = card.querySelector('[data-quota-tokens]'); tokens.replaceChildren();
      for (var i = 0; i < 3; i++) tokens.appendChild(document.createElement('i'));
    });
    q('again').disabled = false;
  }
  function updateConfiguration() {
    var previousConfiguration = state.config && state.config.configuration_id;
    var options = { visualization_mode: 'full_artwork' };
    if (q('use-crop').checked) {
      if (!state.previewCropper || !state.previewCropReady) throw new Error('crop_not_ready');
      if (!previewDimensionsValid()) throw new Error('invalid_preview_dimensions');
      options = { visualization_mode: 'selected_crop', width_cm: state.dimensionsCm.width, height_cm: state.dimensionsCm.height,
        crop: state.previewCropper.getData(), mirror: state.previewCropper.getData().scaleX === -1 };
    }
    state.config = lifecycle().previewSnapshot(options);
    if (previousConfiguration && previousConfiguration !== state.config.configuration_id) releaseResultImage();
    q('configuration').textContent = options.visualization_mode === 'selected_crop' ?
      T('Your framing · {width} × {height} {unit}', { width: q('width').value, height: q('height').value, unit: state.previewUnit === 'in' ? 'in' : 'cm' }) : T('Full artwork · no measurements needed');
    q('crop-thumb').src = state.config.artwork_url;
    if (options.visualization_mode === 'selected_crop') {
      try { q('crop-thumb').src = state.previewCropper.getCroppedCanvas({ maxWidth: 240, maxHeight: 160 }).toDataURL('image/jpeg', .8); } catch (_) {}
    }
    q('crop-thumb').hidden = false;
  }
  function previewDimensionsValid() {
    var width = state.dimensionsCm.width, height = state.dimensionsCm.height;
    return Number.isFinite(width) && width >= 100 && width <= 3000 && Number.isFinite(height) && height >= 100 && height <= 800;
  }
  function setPreviewUnit(unit) {
    if (state.busy || !/^(cm|in)$/.test(unit)) return;
    state.previewUnit = unit;
    var factor = unit === 'in' ? 2.54 : 1;
    ['width', 'height'].forEach(function (name) {
      var input = q(name), cm = state.dimensionsCm[name];
      input.value = Number.isFinite(cm) ? String(Number((cm / factor).toFixed(2))) : '';
      input.min = String(Number((100 / factor).toFixed(2))); input.max = String(Number(((name === 'width' ? 3000 : 800) / factor).toFixed(2)));
    });
    overlay.querySelectorAll('[data-wp-unit]').forEach(function (button) { button.setAttribute('aria-pressed', String(button.dataset.wpUnit === unit)); });
    overlay.querySelectorAll('[data-wp-unit-label]').forEach(function (label) { label.textContent = unit === 'in' ? 'in' : 'cm'; });
    // A display-unit change must not change the physical crop or its fingerprint.
    if (state.config) { try { updateConfiguration(); } catch (_) {} }
  }
  function refinementChanged(resize) {
    if (state.busy) return;
    if (!q('use-crop').checked) { q('crop-tools').hidden = true; notice(''); updateConfiguration(); return; }
    q('crop-tools').hidden = false;
    if (!state.previewCropReady) { ensurePreviewCropper(); return; }
    if (!previewDimensionsValid()) {
      state.config = null;
      q('crop-hint').textContent = state.previewUnit === 'in' ? T('Width: 39.37–1181.10 in. Height: 39.37–314.96 in.') : T('Enter a width from 100 to 3000 cm and a height from 100 to 800 cm to continue.'); return;
    }
    if (resize) state.previewCropper.setAspectRatio(state.dimensionsCm.width / state.dimensionsCm.height);
    q('crop-hint').textContent = T('Drag the artwork to choose your framing.'); notice('');
    try { updateConfiguration(); track('mural_crop_confirmed', { stage: 'preview_refinement' }, 'crop:' + state.config.configuration_id); }
    catch (_) { state.config = null; }
  }
  function resizePreviewCropper() {
    var cropper = state.previewCropper, width = q('crop-canvas').clientWidth;
    if (!cropper || !state.previewCropReady || state.busy || overlay.hidden || phase !== 'artwork' ||
        !q('use-crop').checked || !width || width === state.cropLayoutWidth) return;
    var data = cropper.getData();
    cropper.clear(); cropper.render(); cropper.crop();
    cropper.setData({ width: data.width, height: data.height, scaleX: data.scaleX, scaleY: data.scaleY, rotate: data.rotate });
    cropper.setData({ x: data.x, y: data.y }); state.cropLayoutWidth = width;
    refinementChanged(false);
  }
  function ensurePreviewCropper() {
    if (state.previewCropper || !q('use-crop').checked || phase !== 'artwork') return;
    if (typeof window.Cropper !== 'function') { notice(T('The crop tool could not load. You can continue with the full artwork.')); return; }
    var source = lifecycle().currentPreviewConfiguration() || lifecycle().previewSnapshot();
    q('crop-source').src = source.artwork_url;
    state.previewCropper = new window.Cropper(q('crop-source'), {
      viewMode: 1, dragMode: 'move', aspectRatio: previewDimensionsValid() ? state.dimensionsCm.width / state.dimensionsCm.height : 1,
      autoCropArea: 1, responsive: false, restore: true, rotatable: false, scalable: true, zoomable: false,
      movable: false, cropBoxResizable: false, cropBoxMovable: true,
      toggleDragModeOnDblclick: false, background: false, checkCrossOrigin: true,
      ready: function () {
        state.previewCropReady = true; state.cropLayoutWidth = q('crop-canvas').clientWidth;
        if (state.savedRefinement) { state.previewCropper.scaleX(state.savedRefinement.mirror ? -1 : 1); state.previewCropper.setData(state.savedRefinement.crop); }
        refinementChanged(false);
      },
      cropend: function () { refinementChanged(false); }
    });
    q('crop-source').addEventListener('error', function () { state.previewCropReady = false; notice(T('The crop tool could not load. You can continue with the full artwork.')); });
  }
  function open() {
    if (!lifecycle() || !lifecycle().ready() || (overlay && !overlay.hidden)) return;
    if (!overlay) {
      overlay = document.getElementById('ema-wp-tpl').content.firstElementChild.cloneNode(true);
      overlay.hidden = true; overlay.querySelector('.ema-wp-panel').tabIndex = -1;
      document.body.appendChild(overlay); wire();
    }
    returnFocus = document.activeElement; previousOverflow = document.documentElement.style.overflow;
    overlay.hidden = false; overlay.style.display = 'flex'; document.documentElement.style.overflow = 'hidden';
    state.background = Array.from(document.body.children).filter(function (node) { return node !== overlay && !node.inert; });
    state.background.forEach(function (node) { node.inert = true; });
    q('staging-note').hidden = enabled; q('email-go').disabled = !enabled || state.busy;
    notice('');
    if (state.busy) { show(state.verificationPhase || 'loading'); return; }
    if (!state.initialized) {
      state.savedRefinement = lifecycle().currentPreviewConfiguration();
      if (state.savedRefinement && state.savedRefinement.visualization_mode === 'selected_crop') {
        state.dimensionsCm = { width: Number(state.savedRefinement.width_cm), height: Number(state.savedRefinement.height_cm) };
        q('use-crop').checked = true; setPreviewUnit(state.previewUnit); q('crop-tools').hidden = false;
        state.config = state.savedRefinement;
      } else updateConfiguration();
      state.initialized = true;
    } else { try { updateConfiguration(); } catch (_) { state.config = null; } }
    if (!state.newPhoto && state.config && state.result && state.result.configuration_id === state.config.configuration_id) { viewResult(state.result); return; }
    show(state.file ? 'artwork' : 'intro');
    q('reuse-photo').hidden = !state.file;
    var saved = lifecycle().preview();
    q('last').hidden = !saved || !saved.url;
    if (saved && saved.url) { q('last-img').src = saved.url; q('last-img').onerror = function () { q('last').hidden = true; }; }
    state.remote = lifecycle().remote();
    if (!state.newPhoto && state.config && enabled && state.remote && state.remote.api_base === api) refreshSaved();
    if (lifecycle().previewReturnInvalid()) notice(T('Your saved framing could not be restored. You can use the full artwork or choose a new framing below.'));
    track('mural_preview_open', { stage: 'intro' });
  }
  function close() {
    releaseResultImage();
    if (emailSession) cancelEmailSession();
    else if (state.busy && state.verificationPhase) {
      // Cancel preparation or a trusted identity exchange before verification;
      // an eventual response cannot start a hidden photo upload.
      state.attempt++; state.verificationPhase = null; setBusy(false);
    }
    overlay.hidden = true; overlay.style.display = 'none'; document.documentElement.style.overflow = previousOverflow || '';
    if (state.background) { state.background.forEach(function (node) { node.inert = false; }); state.background = null; }
    if (returnFocus && returnFocus.isConnected) returnFocus.focus({ preventScroll: true });
  }
  function edit() { if (state.busy) return; notice(''); show(state.file ? 'artwork' : 'intro'); }
  function continueToProduct() { close(); document.getElementById('mural-configuration').scrollIntoView({ behavior: 'smooth', block: 'start' }); document.getElementById('customWidth').focus({ preventScroll: true }); }
  function errorCopy(code, context) {
    // Context is an internal presentation selector, never a backend message.
    if (context === 'preview_load_failed') return T('Your preview could not be loaded. Please reopen your saved project.');
    if (context === 'saved_image_expired') return T('The saved image is unavailable or expired. Open your saved project to check it.');
    if (context === 'preview_processing') return T('Your preview is still processing. Open your saved project to check its progress.');
    switch (code) {
      case 'trials_exhausted': return T('You have used your available previews. Continue with your mural or open your saved project.');
      case 'moderation_blocked': return T('We could not use this room photo. Please choose another photo.');
      case 'generation_failed': return T('We could not create your preview. Check your saved project before trying again.');
      case 'project_not_found': return T('This saved project is no longer available. Start a new configuration.');
      case 'project_expiring': return T('Your saved project is near expiry. Please reopen it or start a new configuration.');
      case 'project_version_conflict': return T('Your saved project has changed. Reopen it to review the latest configuration.');
      case 'project_generation_in_progress':
      case 'generation_in_progress': return T('Your preview is still processing. Open your saved project to check its progress.');
      case 'email_verification_required': return T('Please verify your email before creating a room preview.');
      case 'invalid_image':
      case 'image_too_large': return T('Choose a JPEG, PNG or WebP photo up to 20 MB.');
      case 'project_product_not_found':
      case 'project_product_not_mural':
      case 'project_variant_mismatch':
      case 'project_artwork_mismatch':
      case 'project_configuration_mismatch':
      case 'invalid_project_metadata': return T('We could not display your preview. Check your saved project before trying again.');
      case 'project_service_not_configured':
      case 'project_storage_busy':
      case 'shop_unavailable':
      case 'storage_busy': return T('Room previews are temporarily unavailable. Please try again later.');
      case 'contact_invalid_request': return T('Please enter a valid email address.');
      case 'contact_binding_mismatch':
      case 'contact_access_required': return T('Your preview session needs to be refreshed. Please try again.');
      case 'contact_unavailable': return T('Room previews are temporarily unavailable. Please try again later.');
      case 'contact_rate_limited':
      case 'ip_rate_limited': return T('Too many preview requests. Please try again later.');
      default: return configuredCopy('error_generic', T('We could not display your preview. Check your saved project before trying again.'));
    }
  }
  function failure(code, context) {
    if (state.resultImageUrl || state.imageAbort) releaseResultImage();
    clearInterval(timer); clearTimeout(state.observer); setBusy(false);
    state.verificationPhase = null;
    q('err-msg').textContent = errorCopy(code, context); show('error');
    track(code === 'trials_exhausted' ? 'mural_preview_quota_reached' : 'mural_preview_failed',
      { stage: 'generation', error_code: /^(trials_exhausted|moderation_blocked|generation_failed|project_not_found|project_expiring|project_version_conflict|project_generation_in_progress|email_verification_required|invalid_image|image_too_large)$/.test(code) ? code : 'request_failed' });
  }
  function loading() {
    show('loading'); setBusy(true); clearInterval(timer);
    var messages = [configuredCopy('loading1', T('Analyzing your wall…')), configuredCopy('loading2', T('Fitting the mural to your wall…')), configuredCopy('loading3', T('Adding light and shadows…'))], index = 0;
    q('load-msg').textContent = messages[0]; q('bar').style.width = '12%';
    timer = setInterval(function () { index++; q('load-msg').textContent = messages[Math.min(index, 2)];
      q('bar').style.width = Math.min(90, 12 + index * 17) + '%'; }, 12000);
  }
  async function jsonFetch(url, options, expectedStatus) {
    var response = await fetch(url, Object.assign({}, options, {
      credentials: 'omit', cache: 'no-store', redirect: 'error', referrerPolicy: 'no-referrer'
    })), body;
    try { body = await response.json(); } catch (_) { throw new Error('invalid_response'); }
    if (!response.ok) { var error = new Error('request_failed');
      error.code = body && typeof body.code === 'string' ? body.code : 'request_failed'; error.status = response.status;
      error.retryAfter = body && body.retry_after_seconds; throw error; }
    if (expectedStatus && response.status !== expectedStatus) throw new Error('invalid_response');
    return body;
  }
  function codeError(message) {
    q('code-error').textContent = message || ''; q('code-error').hidden = !message;
    q('code').setAttribute('aria-invalid', message ? 'true' : 'false');
  }
  function emailTimeLeft(until) { return Math.max(0, Math.ceil((until - Date.now()) / 1000)); }
  function emailTick() {
    var session = emailSession; if (!session) return;
    var cooldown = emailTimeLeft(session.resendAt), expired = session.expiresAt && emailTimeLeft(session.expiresAt) === 0;
    q('code-resend').disabled = session.pending || cooldown > 0;
    q('code-resend').textContent = cooldown > 0 ? T('Send a new code in {seconds}s', { seconds: cooldown }) : T('Send a new code');
    q('code-verify').disabled = session.pending || !session.challengeId || expired || emailTimeLeft(session.verifyAfter) > 0;
    q('code').disabled = session.pending;
    if (session.challengeId && !expired) {
      var seconds = emailTimeLeft(session.expiresAt);
      q('code-help').textContent = T('Code expires in {time}.', { time: Math.floor(seconds / 60) + ':' + String(seconds % 60).padStart(2, '0') });
    } else if (expired) {
      q('code-help').textContent = T('This code has expired. Request a new one to continue.');
      track('mural_verification_failed', { stage: 'verification', error_code: 'otp_expired' }, 'otp-expired:' + session.eventId);
    } else q('code-help').textContent = T('Use the most recent 8-digit code in your inbox.');
  }
  function finishEmailSession(error, identity) {
    var session = emailSession; if (!session) return;
    emailSession = null; clearInterval(emailTimer); state.verificationPhase = null; q('code').value = '';
    if (error) session.reject(error); else session.resolve(identity);
  }
  function cancelEmailSession() {
    if (!emailSession) return;
    var error = new Error('Email verification cancelled.'); error.code = 'verification_cancelled';
    finishEmailSession(error);
  }
  function emailFailure(session, error, operation) {
    if (emailSession !== session) return;
    session.pending = false;
    if (error.status === 409 && error.code === 'project_expiring' || error.status === 404 && error.code === 'project_not_found') {
      error.remote_project_id = session.context.project_id;
      finishEmailSession(error); return;
    }
    var code = error.code || (operation === 'verify' ? 'otp_verify_unknown' : 'otp_request_unknown');
    var allowed = /^(otp_invalid_request|otp_invalid_code|otp_rate_limited|otp_delivery_unavailable|otp_verification_unavailable|otp_verify_unknown|otp_request_unknown)$/;
    track('mural_verification_failed', { stage: 'verification', error_code: allowed.test(code) ? code : 'otp_verification_unavailable' });
    var message;
    if (code === 'otp_rate_limited') {
      var delay = Number.isFinite(Number(error.retryAfter)) ? Math.max(1, Math.min(3600, Number(error.retryAfter))) : 60;
      if (operation === 'verify') session.verifyAfter = Date.now() + delay * 1000;
      else session.resendAt = Date.now() + delay * 1000;
      message = T('Please wait {seconds} seconds before trying again.', { seconds: Math.ceil(delay) });
    } else if (operation === 'verify' && code === 'otp_invalid_code') {
      message = T('That code could not be verified. Check the most recent email or request a new code.');
      q('code').value = '';
    } else if (operation === 'verify') {
      // A lost response may have consumed the code. Never replay verification
      // and never infer proof: the customer must request a fresh code.
      session.challengeId = null; session.expiresAt = 0; q('code').value = '';
      message = T('We could not confirm this code. Request a new code to continue. Your photo has not been uploaded.');
    } else {
      message = code === 'otp_delivery_unavailable' || code === 'otp_verification_unavailable' ?
        T('Email verification is temporarily unavailable. Your photo is still on this device. Please try again later.') :
        T('We could not confirm that a code was sent. Wait a moment, then request a new code.');
    }
    q('code-status').textContent = ''; codeError(message); emailTick();
    if (!q('code').disabled && session.challengeId) q('code').focus({ preventScroll: true });
  }
  async function emailRequest() {
    var session = emailSession;
    if (!session || session.pending || emailTimeLeft(session.resendAt) > 0) return;
    var previous = { challengeId: session.challengeId, expiresAt: session.expiresAt };
    session.pending = true; session.challengeId = null; session.expiresAt = 0;
    session.resendAt = Date.now() + 60000; session.verifyAfter = 0;
    q('code').value = ''; codeError(''); q('code-status').textContent = T('Sending your verification code…'); emailTick();
    try {
      var response = await jsonFetch(api + '/projects/' + encodeURIComponent(session.context.project_id) + '/identity/email/request', {
        method: 'POST', headers: { Authorization: 'Bearer ' + session.context.project_token, 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: session.context.email }) }, 202);
      if (emailSession !== session) return;
      if (response.status !== 'verification_pending' || typeof response.challenge_id !== 'string' || !response.challenge_id ||
          !Number.isFinite(Number(response.expires_at)) || Number(response.expires_at) * 1000 <= Date.now()) throw new Error('invalid_response');
      session.challengeId = response.challenge_id; session.expiresAt = Number(response.expires_at) * 1000;
      session.resendAt = Date.now() + Math.max(0, Number(response.resend_after_seconds) || 60) * 1000;
      session.pending = false; session.eventId = lifecycle().uuid();
      track('mural_verification_requested', { stage: 'verification' });
      q('code-status').textContent = T('Code requested. Check your inbox and spam folder.'); emailTick(); q('code').focus({ preventScroll: true });
    } catch (error) {
      // The service explicitly preserves the previous code on a cooldown reject.
      if (error.status === 429) { session.challengeId = previous.challengeId; session.expiresAt = previous.expiresAt; }
      emailFailure(session, error, 'request');
    }
  }
  async function emailVerify() {
    var session = emailSession;
    if (!session || session.pending || !session.challengeId || emailTimeLeft(session.expiresAt) === 0 || emailTimeLeft(session.verifyAfter) > 0) return;
    var code = q('code').value.replace(/\D/g, '');
    if (!/^\d{8}$/.test(code)) { codeError(T('Enter the 8-digit code from your latest email.')); q('code').focus(); return; }
    session.pending = true; codeError(''); q('code-status').textContent = T('Verifying your code…'); emailTick();
    try {
      var response = await jsonFetch(api + '/projects/' + encodeURIComponent(session.context.project_id) + '/identity/email/verify', {
        method: 'POST', headers: { Authorization: 'Bearer ' + session.context.project_token, 'Content-Type': 'application/json' },
        body: JSON.stringify({ challenge_id: session.challengeId, code: code }) }, 200);
      if (emailSession !== session) return;
      if (response.status !== 'success' || typeof response.identity_token !== 'string' || !response.identity_token ||
          !Number.isFinite(Number(response.identity_expires_at)) || Number(response.identity_expires_at) * 1000 <= Date.now()) throw new Error('invalid_response');
      track('mural_verification_completed', { stage: 'verification' }, 'otp-complete:' + session.eventId);
      finishEmailSession(null, { identity_token: response.identity_token, expires_at: response.identity_expires_at, method: 'email' });
    } catch (error) { emailFailure(session, error, 'verify'); }
  }
  function emailIdentity(context) {
    return new Promise(function (resolve, reject) {
      clearInterval(timer); state.verificationPhase = 'verify';
      emailSession = { context: Object.assign({}, context), resolve: resolve, reject: reject, pending: false,
        challengeId: null, expiresAt: 0, resendAt: 0, verifyAfter: 0, eventId: lifecycle().uuid() };
      var parts = context.email.split('@'); q('code-email').textContent = parts[0].slice(0, 2) + '•••@' + parts[1];
      q('code-change-email').hidden = false; show('verify');
      clearInterval(emailTimer); emailTimer = setInterval(emailTick, 1000); emailRequest();
    });
  }
  async function refreshSaved() {
    var configuration = state.config.configuration_id;
    try {
      var body = await jsonFetch(api + '/projects/' + encodeURIComponent(state.remote.project_id),
        { headers: { Authorization: 'Bearer ' + state.remote.project_token } });
      if (state.busy || state.newPhoto || !state.config || state.config.configuration_id !== configuration) return;
      var savedConfiguration = body.preview_metadata && body.preview_metadata.configuration_id;
      if (body.state === 'succeeded' && body.preview_url && savedConfiguration === configuration) {
        state.remote.project_url = body.project_url;
        viewResult(body);
      } else if (body.state === 'processing' && savedConfiguration === configuration) {
        loading(); poll(++state.attempt, 60);
      }
    } catch (_) { notice(T('Your saved configuration is available here. The room image may have expired.')); }
  }
  function releaseResultImage() {
    state.imageReadId = (state.imageReadId || 0) + 1;
    if (state.imageAbort) { state.imageAbort.abort(); state.imageAbort = null; }
    if (state.resultImageUrl) {
      URL.revokeObjectURL(state.resultImageUrl);
      if (overlay) { q('result-img').removeAttribute('src'); q('result-img').onload = q('result-img').onerror = null; }
    }
    state.resultImageUrl = null; state.resultImageData = null;
  }
  async function loadPrivateResult(data) {
    releaseResultImage();
    state.result = null;
    var remote = state.remote, configuration = state.config && state.config.configuration_id;
    var imageReadId = state.imageReadId;
    // Only the known service and exact owned project route may receive the
    // capability. Server-supplied redirects/queries/other origins are rejected.
    var expected = remote && api + '/projects/' + encodeURIComponent(remote.project_id) + '/preview';
    if (!remote || !remote.project_token || !/^https:\/\//.test(api) || data.preview_url !== expected ||
        (data.project_id && data.project_id !== remote.project_id)) {
      failure('invalid_image', 'preview_load_failed'); return;
    }
    state.result = Object.assign({}, data, { configuration_id: configuration });
    state.newPhoto = false;
    if (overlay.hidden) return;
    var controller = new AbortController(); state.imageAbort = controller;
    function current() { return imageReadId === state.imageReadId && !overlay.hidden &&
      remote === state.remote && state.config && configuration === state.config.configuration_id; }
    try {
      var response = await fetch(expected, { method: 'GET', headers: { Authorization: 'Bearer ' + remote.project_token },
        credentials: 'omit', redirect: 'error', cache: 'no-store', referrerPolicy: 'no-referrer', signal: controller.signal });
      if (!current()) return;
      var length = Number(response.headers.get('Content-Length'));
      var type = (response.headers.get('Content-Type') || '').split(';')[0].trim().toLowerCase();
      if (!response.ok || response.redirected || (response.url && response.url !== expected) ||
          !/^image\/(jpeg|png|webp)$/.test(type) || length > 24 * 1024 * 1024) throw new Error('invalid_image');
      var blob = await response.blob();
      if (!current()) return;
      if (!blob.size || blob.size > 24 * 1024 * 1024 || blob.type.split(';')[0].toLowerCase() !== type) throw new Error('invalid_image');
      state.resultImageUrl = URL.createObjectURL(blob); state.resultImageData = data;
      state.imageAbort = null; viewResult(data);
    } catch (_) {
      // Never log a URL, provider response or capability, and never downgrade
      // to a query-signed image when authenticated retrieval fails.
      if (current()) { state.imageAbort = null; failure('invalid_image', 'saved_image_expired'); }
    }
  }
  function viewResult(data) {
    clearInterval(timer); clearTimeout(state.observer); setBusy(false);
    if (data.trials_used !== undefined) trials(Number(data.trials_used), Number(data.trials_limit));
    if (data.preview_transport && data.preview_transport !== 'header') { failure('invalid_image', 'preview_load_failed'); return; }
    if (data.preview_transport === 'header' && (state.resultImageData !== data || !state.resultImageUrl)) return loadPrivateResult(data);
    if (data.preview_transport !== 'header' && (state.resultImageUrl || state.imageAbort)) releaseResultImage();
    var url = data.preview_url;
    if (!url || !/^https:\/\//.test(url)) { failure('invalid_image', 'preview_load_failed'); return; }
    state.result = Object.assign({}, data, { configuration_id: state.config.configuration_id });
    state.newPhoto = false;
    lifecycle().savePreview({ job_id: data.job_id, preview_url: data.preview_transport === 'header' ? '' : url,
      project_url: state.remote && state.remote.project_url, configuration_id: state.config.configuration_id });
    var img = q('result-img'), viewedKey = data.job_id || state.config.configuration_id;
    function seenResult() {
      if (overlay.hidden || phase !== 'result' || img.hidden || document.visibilityState === 'hidden' || !img.complete || !img.naturalWidth) return;
      if (!state.viewed.has(viewedKey)) {
        if (track('mural_preview_viewed', { stage: 'result' }, 'result:' + viewedKey)) state.viewed.add(viewedKey);
      }
    }
    img.onload = seenResult;
    img.onerror = function () { failure('invalid_image', 'saved_image_expired'); };
    img.src = data.preview_transport === 'header' ? state.resultImageUrl : url;
    img.hidden = false;
    q('original-img').hidden = true;
    // A server-restored result has no matching local original by default.
    // Never compare a newly selected room to an older generated result.
    q('compare').hidden = !state.photoUrl || data.original_photo_url !== state.photoUrl;
    q('compare').querySelectorAll('button').forEach(function (button) { button.setAttribute('aria-pressed', String(button.dataset.wpCompare === 'after')); });
    var link = q('saved-link'), projectUrl = state.remote && state.remote.project_url;
    link.hidden = !projectUrl;
    q('trials3').closest('[data-wp-quota]').hidden = state.remaining === null;
    q('again').disabled = state.remaining === 0;
    show('result'); seenResult();
    // Result receives credit only after loaded + visible, including a tab returning later.
    if (state.visibilityHandler) document.removeEventListener('visibilitychange', state.visibilityHandler);
    state.visibilityHandler = seenResult;
    document.addEventListener('visibilitychange', seenResult);
  }
  function accepted(body) {
    if (!body.job_id || body.job_id === state.remote.previous_job_id) return;
    track('mural_preview_started', { stage: 'generation' }, 'started-job:' + body.job_id);
    // A reserved job is authoritative evidence that the server resolved the lead.
    track('mural_lead_captured', { stage: 'lead' }, 'lead:' + state.remote.project_id);
  }
  async function observeAccepted(attempt) {
    if (attempt !== state.attempt || !state.busy) return;
    var observedRemote = state.remote;
    try {
      var body = await jsonFetch(api + '/projects/' + encodeURIComponent(observedRemote.project_id),
        { headers: { Authorization: 'Bearer ' + observedRemote.project_token } });
      if (attempt !== state.attempt || !state.busy || observedRemote !== state.remote) return;
      if ((body.state === 'processing' || body.state === 'succeeded' || body.state === 'failed') &&
          body.job_id && body.job_id !== state.remote.previous_job_id) { accepted(body); return; }
    } catch (_) {}
    if (observedRemote !== state.remote) return;
    state.observer = setTimeout(function () { observeAccepted(attempt); }, 4000);
  }
  async function poll(attempt, remaining) {
    if (attempt !== state.attempt) return;
    if (remaining <= 0) { failure('request_failed', 'preview_processing'); return; }
    try {
      var body = await jsonFetch(api + '/projects/' + encodeURIComponent(state.remote.project_id),
        { headers: { Authorization: 'Bearer ' + state.remote.project_token } });
      if (body.job_id && body.job_id !== state.remote.previous_job_id) {
        accepted(body);
        if (body.state === 'succeeded' && body.preview_url) {
          var original = state.submittedPhoto && state.submittedPhoto.attempt === attempt &&
            state.submittedPhoto.project_id === state.remote.project_id ? state.submittedPhoto.url : undefined;
          viewResult(Object.assign({}, body, { original_photo_url: original })); return;
        }
        if (body.state === 'failed') { failure(body.error_code); return; }
      }
    } catch (err) {
      if (err.code === 'project_not_found') { failure(err.code); return; }
    }
    setTimeout(function () { poll(attempt, remaining - 1); }, 4000);
  }
  async function contactAccess(request) {
    var sessionKey = 'ema_mural_contact_session_v1:' + api, previous;
    try {
      previous = JSON.parse(localStorage.getItem(sessionKey) || 'null');
      if (!previous || typeof previous.token !== 'string' || !previous.token ||
          !Number.isFinite(Number(previous.expires_at)) || Number(previous.expires_at) * 1000 <= Date.now()) previous = null;
    } catch (_) { previous = null; }
    var payload = { email: request.email, marketing_opt_in: q('optin').checked === true };
    if (previous) payload.anonymous_session_token = previous.token;
    var body = await jsonFetch(api + '/projects/' + encodeURIComponent(request.project_id) + '/contact', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + request.project_token }, body: JSON.stringify(payload)
    });
    if (typeof body.contact_token !== 'string' || !body.contact_token ||
        !Number.isFinite(Number(body.contact_expires_at)) || Number(body.contact_expires_at) * 1000 <= Date.now() ||
        typeof body.anonymous_session_token !== 'string' || !body.anonymous_session_token ||
        !Number.isFinite(Number(body.anonymous_session_expires_at)) || Number(body.anonymous_session_expires_at) * 1000 <= Date.now()) {
      var error = new Error('contact_unavailable'); error.code = 'contact_unavailable'; throw error;
    }
    // Functional access only: no identity lookup, analytics, cart property or URL.
    try { localStorage.setItem(sessionKey, JSON.stringify({ token: body.anonymous_session_token, expires_at: Number(body.anonymous_session_expires_at) })); } catch (_) {}
    return { method: 'contact', contact_token: body.contact_token, expires_at: Number(body.contact_expires_at) };
  }
  async function generate() {
    if (!enabled || state.busy || !state.file) return;
    var identityProvider = contactPreviewEnabled ? { verify: contactAccess, isContact: true, isEmail: true } : window.EMAMuralIdentity;
    if ((!identityProvider || typeof identityProvider.verify !== 'function') && emailVerificationEnabled)
      identityProvider = { verify: emailIdentity, isEmail: true };
    if (!identityProvider || typeof identityProvider.verify !== 'function') {
      notice(T('Secure email verification is not connected yet. Room previews are temporarily unavailable. Your photo has not been uploaded.'));
      track('mural_preview_failed', { stage: 'verification', error_code: 'email_verification_required' });
      return;
    }
    var email = q('email').value.trim().toLowerCase();
    if ((identityProvider.isEmail || !root.dataset.cid) && !/^[^@\s]+@[^@\s]+\.[a-zA-Z]{2,24}$/.test(email)) {
      q('email-err').textContent = configuredCopy('email_invalid', T('Please enter a valid email address.')); q('email-err').hidden = false; q('email').focus(); return;
    }
    q('email-err').hidden = true;
    try { updateConfiguration(); } catch (_) { notice(T('Check your optional dimensions, or turn off artwork adjustment to continue.')); show('artwork'); return; }
    var attempt = ++state.attempt, posted = false, designUrl;
    if (state.resultImageUrl || state.imageAbort) releaseResultImage();
    state.result = null; state.verificationPhase = 'email'; setBusy(true); show('email'); notice(T('Getting your preview ready…'));
    try {
      var identityKey;
      if (state.config.configuration_type === 'visualization') {
        var binding = identityProvider.isContact ? 'contact:' + email : identityProvider.isEmail || !root.dataset.cid ? 'email:' + email : 'customer:' + root.dataset.cid;
        var hashed = await window.crypto.subtle.digest('SHA-256', new TextEncoder().encode(binding));
        if (attempt !== state.attempt) return;
        identityKey = Array.from(new Uint8Array(hashed)).map(function (byte) { return byte.toString(16).padStart(2, '0'); }).join('');
        var existing = lifecycle().remote();
        if (existing && existing.api_base === api && existing.identity_key !== identityKey) {
          // Changing the mailbox starts a new private project. Never reuse the
          // prior owner's proof or invalidate their existing saved link.
          lifecycle().resetRemoteProject(existing.project_id); state.remote = null;
        }
      }
      for (var renewal = 0; renewal < 2; renewal++) {
        posted = false;
        try {
          // A private draft is enough to verify identity. Any legacy print-crop request
          // and the room-photo upload both wait until valid proof is returned.
          state.remote = await lifecycle().ensureRemoteProject(api, state.config, designUrl);
          if (attempt !== state.attempt) return;
          if (identityKey && !lifecycle().bindRemoteIdentity(state.remote.project_id, identityKey)) throw new Error('identity_binding_failed');
          var identity = await identityProvider.verify({ project_id: state.remote.project_id,
            project_token: state.remote.project_token, api_base: api, email: email });
          if (attempt !== state.attempt) return;
          var proof = identity && (identityProvider.isContact ? identity.contact_token : identity.identity_token);
          if (!identity || typeof proof !== 'string' || !proof ||
              !Number.isFinite(Number(identity.expires_at)) || Number(identity.expires_at) * 1000 <= Date.now()) {
            var identityError = new Error('email_verification_required');
            identityError.code = identityProvider.isContact ? 'contact_access_required' : 'email_verification_required'; throw identityError;
          }
          state.verificationPhase = null; notice(''); loading();
          if (!designUrl) designUrl = state.config.configuration_type === 'visualization' ? state.config.artwork_url : await lifecycle().cropFor(state.config);
          // Proof is scoped to this project/customer, not its metadata version.
          state.remote = await lifecycle().ensureRemoteProject(api, state.config, designUrl);
          var form = new FormData();
          form.append('wall_photo', state.file, 'room-photo'); form.append('product_id', state.config.product_id);
          form.append('product_handle', state.config.product_handle); form.append('design_image_url', designUrl);
          form.append('project_id', state.remote.project_id); form.append('project_token', state.remote.project_token);
          if (identityProvider.isContact) form.append('contact_token', identity.contact_token);
          else {
            form.append('identity_token', identity.identity_token);
            if (identity.method !== 'email' && root.dataset.cid) form.append('shopify_customer_id', root.dataset.cid);
            else form.append('email', email);
          }
          // Verification is separate from optional marketing permission.
          form.append('marketing_opt_in', q('optin').checked ? 'true' : 'false');
          track('mural_preview_requested', { stage: 'generation' });
          state.submittedPhoto = { attempt: attempt, project_id: state.remote.project_id, url: state.photoUrl };
          posted = true;
          state.observer = setTimeout(function () { observeAccepted(attempt); }, 4000);
          var body = await jsonFetch(api + '/generate', { method: 'POST', body: form });
          accepted(body); viewResult(Object.assign({}, body, { original_photo_url: state.submittedPhoto.url })); return;
        } catch (error) {
          clearTimeout(state.observer);
          if (attempt !== state.attempt) return;
          var expiredProject = error.status === 409 && error.code === 'project_expiring';
          var missingBeforeUpload = !posted && error.status === 404 && error.code === 'project_not_found';
          var rejectedProject = Object.prototype.hasOwnProperty.call(error, 'remote_project_id') ?
            error.remote_project_id : state.remote && state.remote.project_id;
          if (renewal === 0 && (expiredProject || missingBeforeUpload) && rejectedProject &&
              lifecycle().resetRemoteProject(rejectedProject)) {
            // Explicit stale metadata/OTP errors are safe to recover before
            // upload. New project => new proof; never replay a missing or
            // ambiguous generation response. Preserve the local photo/config.
            state.remote = null;
            clearInterval(timer); state.verificationPhase = 'email'; show('email');
            notice(expiredProject ? T('Your saved project is near expiry. Preparing a new secure project for this same configuration.') : T('Getting your preview ready…'));
            continue;
          }
          throw error;
        }
      }
    } catch (error) {
      if (error.code === 'verification_cancelled') {
        setBusy(false); notice(''); show('email'); q('email').readOnly = false; q('email').focus({ preventScroll: true }); return;
      }
      if (posted && state.remote && (!error.code || error.code === 'generation_in_progress')) {
        // Lost generation response: read status, never automatically resubmit.
        poll(attempt, 60); return;
      }
      failure(error.code || 'request_failed');
    }
  }
  function wire() {
    window.addEventListener('pagehide', releaseResultImage);
    window.addEventListener('resize', function () { requestAnimationFrame(resizePreviewCropper); });
    overlay.querySelector('.ema-wp-close').addEventListener('click', close);
    overlay.addEventListener('click', function (event) { if (event.target === overlay) close(); });
    overlay.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') { event.preventDefault(); close(); }
      if (event.key !== 'Tab') return;
      var items = Array.from(overlay.querySelectorAll('button:not(:disabled),a[href],input:not([hidden]):not(:disabled),summary,[tabindex="0"]')).filter(function (node) { return node.getClientRects().length; });
      if (!items.length) return;
      if (event.shiftKey && (document.activeElement === items[0] || document.activeElement === overlay.querySelector('.ema-wp-panel'))) { event.preventDefault(); items[items.length - 1].focus(); }
      else if (!event.shiftKey && document.activeElement === items[items.length - 1]) { event.preventDefault(); items[0].focus(); }
    });
    q('use-crop').addEventListener('change', function () { refinementChanged(true); });
    ['width', 'height'].forEach(function (name) { q(name).addEventListener('input', function () {
      var input = q(name), value = input.value.trim();
      state.dimensionsCm[name] = value ? Math.round(Number(value) * (state.previewUnit === 'in' ? 2.54 : 1) * 1000) / 1000 : NaN;
      refinementChanged(true);
    }); });
    overlay.querySelectorAll('[data-wp-unit]').forEach(function (button) { button.addEventListener('click', function () { setPreviewUnit(button.dataset.wpUnit); }); });
    overlay.querySelectorAll('[data-wp-back]').forEach(function (button) { button.addEventListener('click', function () {
      if (!state.busy) { notice(''); show(button.dataset.wpBack); }
    }); });
    q('reuse-photo').addEventListener('click', function () { if (state.file && !state.busy) { setBusy(false); show('artwork'); } });
    q('artwork-go').addEventListener('click', function () {
      if (!state.file || state.busy) return;
      try { updateConfiguration(); } catch (_) { notice(T('Check your optional dimensions, or turn off artwork adjustment to continue.')); return; }
      notice(''); show('email'); q('email').focus({ preventScroll: true });
    });
    overlay.querySelector('.ema-wp-upload-cta').addEventListener('keydown', function (event) {
      if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); q('file').click(); }
    });
    q('file').addEventListener('change', async function (event) {
      var file = event.target.files && event.target.files[0]; event.target.value = '';
      if (!file || state.busy) return;
      var readId = state.photoReadId = (state.photoReadId || 0) + 1;
      if (!/^image\/(jpeg|png|webp)$/.test(file.type) || file.size > 20 * 1024 * 1024) {
        notice(T('Choose a JPEG, PNG or WebP photo up to 20 MB.'));
        track('mural_preview_failed', { stage: 'photo', error_code: file.size > 20 * 1024 * 1024 ? 'image_too_large' : 'invalid_image' }); return;
      }
      try {
        var decoded = await createImageBitmap(file);
        if (!decoded.width || !decoded.height) throw new Error('invalid_image');
        decoded.close();
      } catch (_) { if (readId !== state.photoReadId || state.busy) return; notice(T('This photo could not be read. Please choose another JPEG, PNG or WebP image.')); track('mural_preview_failed', { stage: 'photo', error_code: 'invalid_image' }); return; }
      if (readId !== state.photoReadId || state.busy) return;
      releaseResultImage(); state.newPhoto = true; state.result = null;
      state.file = file; q('photo-ok').textContent = T('Your room photo is ready');
      var nextEmail = root.dataset.cemail || q('email').value || '';
      if (nextEmail !== q('email').value) clearQuota();
      q('email').value = nextEmail;
      if (state.photoUrl) URL.revokeObjectURL(state.photoUrl);
      state.photoUrl = URL.createObjectURL(file); q('room-photo').src = state.photoUrl; q('original-img').src = state.photoUrl;
      q('email').readOnly = !contactPreviewEnabled && !!root.dataset.cid && !!(window.EMAMuralIdentity && typeof window.EMAMuralIdentity.verify === 'function');
      track('mural_photo_ready', { stage: 'photo' }); setBusy(false);
      if (!overlay.hidden) show('artwork');
    });
    q('email').addEventListener('input', clearQuota);
    q('email-go').addEventListener('click', generate);
    q('email').addEventListener('keydown', function (event) { if (event.key === 'Enter') { event.preventDefault(); generate(); } });
    q('code-verify').addEventListener('click', emailVerify);
    q('code-resend').addEventListener('click', emailRequest);
    q('code-change-email').addEventListener('click', cancelEmailSession);
    q('code').addEventListener('input', function () { this.value = this.value.replace(/\D/g, '').slice(0, 8); });
    q('code').addEventListener('paste', function (event) {
      var digits = (event.clipboardData && event.clipboardData.getData('text') || '').replace(/\D/g, '');
      if (digits.length === 8) { event.preventDefault(); this.value = digits; }
    });
    q('code').addEventListener('keydown', function (event) { if (event.key === 'Enter') { event.preventDefault(); emailVerify(); } });
    q('done').addEventListener('click', function () { track('mural_preview_continue', { stage: 'result' }); continueToProduct(); });
    q('again').addEventListener('click', function () { track('mural_preview_retry', { stage: 'photo' }); show('intro'); });
    q('retry').addEventListener('click', function () { track('mural_preview_retry', { stage: 'generation' }); show(state.file ? 'artwork' : 'intro'); });
    q('saved-link').addEventListener('click', function () {
      if (!state.remote || !state.remote.project_url) return;
      track('mural_project_saved', { stage: 'result' });
      // Do not put a capability in href/data attributes: automatic outbound-link
      // tracking could otherwise collect the token in link_url.
      window.open(state.remote.project_url, '_blank', 'noopener,noreferrer');
    });
    q('compare').querySelectorAll('button').forEach(function (button) { button.addEventListener('click', function () {
      var original = button.dataset.wpCompare === 'before';
      q('original-img').hidden = !original; q('result-img').hidden = original;
      q('compare').querySelectorAll('button').forEach(function (item) { item.setAttribute('aria-pressed', String(item === button)); });
      if (!original && state.visibilityHandler) state.visibilityHandler();
    }); });
  }
  function mount() {
    if (!lifecycle()) return;
    // Separate fallbacks: a selector list returns document order and would
    // select the outer gallery before its viewer, placing the CTA on thumbnails.
    var host = document.querySelector('.media-gallery__viewer') || document.querySelector('.product__media-wrapper .product__media') ||
      document.querySelector('.product__media-list li:first-child') || document.querySelector('media-gallery, .product__media-wrapper');
    if (host && !host.querySelector('.ema-wp-btn')) {
      if (getComputedStyle(host).position === 'static') host.style.position = 'relative';
      var button = document.createElement('button'); button.type = 'button'; button.className = 'ema-wp-btn';
      button.innerHTML = '<span class="ema-wp-btn-ic" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M3 20V7l7-4 7 4v13H3Z"/><path d="M10 3v17M3 20l7-4 7 4M20 3v6m-3-3h6"/></svg></span>';
      var label = document.createElement('span'); label.textContent = configuredCopy('button_label', T('See it on my wall')); button.appendChild(label);
      button.setAttribute('aria-haspopup', 'dialog'); button.addEventListener('click', open); host.appendChild(button);
    }
    document.querySelectorAll('.ema-wp-btn,[data-ema-open-preview]').forEach(function (button) { button.disabled = !lifecycle().ready(); });
    document.querySelectorAll('[data-ema-open-preview]').forEach(function (button) { if (!button.dataset.bound) { button.dataset.bound = 'true'; button.setAttribute('aria-haspopup', 'dialog'); button.addEventListener('click', open); } });
    if (location.hash === '#wall-preview' || lifecycle().takePreviewReturn()) open();
  }
  window.addEventListener('hashchange', function () { if (location.hash === '#wall-preview') open(); });
  document.addEventListener('ema:mural-ready', mount);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount); else mount();
})();
